export interface IUsersFilterForm {
  id?: string;
  lastName?: string;
  name?: string;
  patronymic?: string;
  phone?: string;
}

export const UsersFilterForm: IUsersFilterForm = {};
